import { render, staticRenderFns } from "./UserEmploymentDetails.vue?vue&type=template&id=6c8f0fa5&scoped=true&"
import script from "./UserEmploymentDetails.vue?vue&type=script&lang=js&"
export * from "./UserEmploymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEmploymentDetails.vue?vue&type=style&index=0&id=6c8f0fa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f0fa5",
  null
  
)

export default component.exports